import { GenericFunction } from '~shared/types/GenericFunction';

export function disposables() {
  const disposables: GenericFunction[] = [];

  const api = {
    requestAnimationFrame(...args: Parameters<typeof requestAnimationFrame>) {
      const raf = requestAnimationFrame(...args);
      api.add(() => cancelAnimationFrame(raf));
    },

    nextFrame(...args: Parameters<typeof requestAnimationFrame>) {
      api.requestAnimationFrame(() => {
        api.requestAnimationFrame(...args);
      });
    },

    setTimeout(...args: Parameters<typeof setTimeout>) {
      const timer = setTimeout(...args);
      api.add(() => clearTimeout(timer));
    },

    add(cb: () => void) {
      disposables.push(cb);
    },

    dispose() {
      for (const dispose of disposables.splice(0)) {
        dispose();
      }
    },
  };

  return api;
}
